import * as React from 'react';

export const LazyConseilDurabilityResults = React.lazy(() => import('./component'));
